import { render, staticRenderFns } from "./Ag-vmenuCustom.vue?vue&type=template&id=1fdec508&scoped=true&"
import script from "./Ag-vmenuCustom.vue?vue&type=script&lang=js&"
export * from "./Ag-vmenuCustom.vue?vue&type=script&lang=js&"
import style0 from "./Ag-vmenuCustom.vue?vue&type=style&index=0&id=1fdec508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdec508",
  null
  
)

export default component.exports